var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-5",attrs:{"data-wizard-type":"step-content"}},[_c('b-container',{attrs:{"fluid":""}},[_vm._t("tab-title",function(){return [_c('b-row',{staticClass:"mb-10 font-weight-bold text-dark",attrs:{"align-h":"start"}},[_c('b-col',[_c('h2',[_vm._v(_vm._s(_vm.title))])])],1)]}),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }